import React, { Component } from 'react';
export const Page = props => (
  <div className="project">

    {/* ==== EDIT BELOW THIS LINE ==== */}
    
    <h1> Digital Color Study: Warm vs. Cool </h1>

    
    <div className="imgs max700">
        <div>
            <img 
                src={require('../assets/drawing/warmCool.png')} 
                data-skip-gallery
                />
        </div>
    </div>

    <p>I created this illustration during my art studies at Carnegie 
    Mellon University in the course <a target="_blank" href={require('../assets/drawing/s17_color.pdf')}>60-452</a>, 
    "Advanced DP3: Color Studio". The 
    assignment was to use hue and saturation effects to create a sense of spatial depth 
    within a restricted value range. I utilitized warm verses cool tones to help add 
    a sense of shadow and light in the girl's room, helping it to feel three dimensional.</p>
    {/* ==== EDIT ABOVE THIS LINE ==== */}

  </div>
)






// worked with the rabbi to developed visual 
    //symbols to represent each of the prayers in the Shabbat in order to guide the members 
    //with ASD through the ceremony. These symbols will be presented to the members via a 
    //large banner on the temple’s stage as well as on personal bookmarks that correspond 
    //with the banner. The bookmarks will also have a sticker packet with the symbols printed 
    //as stickers, to be placed on each of the corresponding sections for the current prayer 
    //on the bookmarks. The visually and physically interactive elements of these materials 
    //will help to add more sensorial aspects to the Shabbat, further benefitting Temple Sinai’s members with ASD.